import React, { useEffect } from "react";
import { useItemsFilter } from "../../../_helper/actions/app/items";
import { ApiEndPoint } from "../../../_helper/constant/api-types";
import { useAtom } from "jotai";
import {
  clinicAtom,
  pharmacyAtom, // Using Jotai Atom for pharmacy state
} from "../../../_helper/constant/constant-atom";

const Header = ({ onMenuClick }) => {
  const [clinic] = useAtom(clinicAtom);
  const [selectedPharmacy, setSelectedPharmacy] = useAtom(pharmacyAtom);

  // Only fetch pharmacies if a valid clinic.id is available.
  const { data: pharmacies } = useItemsFilter(
    `${ApiEndPoint.PHARMACY}?action=getPharmacy&clinic_id=${clinic?.id}`
  );

  console.log(selectedPharmacy?.pharmacy_name);
  const handlePharmacyChange = (e) => {
    const pharmacyId = e.target.value;
    const pharmacyName =
      pharmacies?.find((pharmacy) => pharmacy?.id === pharmacyId)
        ?.pharmacy_name || "";
    setSelectedPharmacy({ id: pharmacyId, name: pharmacyName });
  };

  // Auto-select the first pharmacy when data is fetched and no pharmacy is selected.
  useEffect(() => {
    if (pharmacies?.length > 0 && !selectedPharmacy?.id) {
      setSelectedPharmacy({
        id: pharmacies[0]?.id,
        name: pharmacies[0]?.pharmacy_name,
      });
    }
  }, [pharmacies, selectedPharmacy, setSelectedPharmacy]);

  return (
    <header className="bg-white px-6 flex items-center justify-between">
      {/* Hamburger Menu for Small Screens */}
      <button
        onClick={onMenuClick}
        className="lg:hidden text-gray-700 hover:text-blue-600 text-2xl"
      >
        ☰
      </button>

      {/* Title */}
      <h1 className="text-2xl font-bold text-gray-900">
        Pharma Compliance Dashboard
      </h1>

      {/* Pharmacy Selector */}
      <div className="relative w-64">
        {clinic.id ? (
          // Interactive dropdown if clinic.id is provided.
          <>
            <select
              value={selectedPharmacy?.id || ""}
              onChange={handlePharmacyChange}
              className="block w-full bg-white border border-gray-300 text-gray-800 text-lg font-semibold px-4 py-3 rounded-md appearance-none cursor-pointer transition-all duration-300 focus:ring-2 focus:ring-blue-500 focus:outline-none"
            >
              <option value="" disabled>
                Select Pharmacy
              </option>
              {pharmacies?.map((pharmacy) => (
                <option
                  key={pharmacy?.id}
                  value={pharmacy?.id}
                  className="text-base"
                >
                  {pharmacy?.pharmacy_name}
                </option>
              ))}
            </select>
            {/* Custom Dropdown Icon */}
            <div className="absolute inset-y-0 right-4 flex items-center pointer-events-none">
              <svg
                className="w-5 h-5 text-gray-600 transition-transform duration-200 transform"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M19 9l-7 7-7-7"
                />
              </svg>
            </div>
          </>
        ) : (
          // Static display if clinic.id is missing (or if you want to “lock” the selection)
          <div className="block w-full bg-white border border-gray-300 text-gray-800 text-lg font-semibold px-4 py-3 rounded-md">
            {selectedPharmacy?.pharmacy_name || "Pharmacy Not Selected"}
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
